import { call, put, takeLatest } from 'redux-saga/effects';
// Store
import * as LayoutActions from '../../actions/layout.actions';
import { AvailabilityActionTypes, AvailabilityMessageTypes } from './availability.types';
import { AvailabilityActions } from './availability.actions';
import { AvailabilityService } from './availability.service';

function* _fetchList(action){
  try {
    const { bookingId } = action;
    const response = yield call(AvailabilityService.fetchList, bookingId);
    yield put(AvailabilityActions.fetchListSuccess(response));
  } catch(error){
    console.log(error);
    yield put(AvailabilityActions.setStatusError());
  }
}

function* _create(action){
  try {
    const { data } = action;
    const response = yield call(AvailabilityService.create, data);
    yield put(AvailabilityActions.createSuccess(response));
    yield put(AvailabilityActions.setStatusSuccess());
    yield put(AvailabilityActions.setStatusInitial());
    yield put(LayoutActions.addNotification({
      type: 'success',
      message: AvailabilityMessageTypes.Create
    }));
  } catch(error){
    console.log(error);
    yield put(AvailabilityActions.setStatusError());
    yield put(LayoutActions.addNotification({
      type: 'danger',
      message: error.message
    }));
  }
}

function* _update(action){
  try {
    const { restrictionId, data } = action;
    const response = yield call(AvailabilityService.update, restrictionId, data);
    yield put(AvailabilityActions.updateSuccess(response));
    yield put(AvailabilityActions.setStatusSuccess());
    yield put(AvailabilityActions.setStatusInitial());
    yield put(LayoutActions.addNotification({
      type: 'success',
      message: AvailabilityMessageTypes.Update
    }));
  } catch(error){
    console.log(error);
    yield put(AvailabilityActions.setStatusError());
    yield put(LayoutActions.addNotification({
      type: 'danger',
      message: error.message
    }));
  }
}

function* _delete(action){
  try {
    const { restriction } = action;
    if ( window.confirm(`Are you sure you want to delete booking property availabiliy restriction?`) ){
      yield call(AvailabilityService.delete, restriction.id);
      yield put(AvailabilityActions.deleteSuccess(restriction.id));
      yield put(LayoutActions.addNotification({
        type: 'success',
        message: AvailabilityMessageTypes.Delete
      }));
    }
  } catch(error){
    console.log(error);
    yield put(AvailabilityActions.setStatusError());
    yield put(LayoutActions.addNotification({
      type: 'danger',
      message: error.message
    }));
  }
}

export default function* (){
  yield takeLatest(AvailabilityActionTypes.FetchList, _fetchList);
  yield takeLatest(AvailabilityActionTypes.Create, _create);
  yield takeLatest(AvailabilityActionTypes.Update, _update);
  yield takeLatest(AvailabilityActionTypes.Delete, _delete);
}